/**
 * Patch/rollback puro do status de leitura na lista de NotificationVm.
 */

/**
 * @typedef {import("./to-notification-vm.js").NotificationVm} NotificationVm
 */

/**
 * Retorna cópia rasa do item marcada como lida.
 * @param {Object} item
 * @param {string} [readAtIso]
 * @returns {Object|null}
 */
export function markNotificationAsReadVm(item, readAtIso) {
  if (!item || typeof item !== "object") return null;

  return {
    ...item,
    status: "read",
    readAt:
      typeof readAtIso === "string" && readAtIso.trim()
        ? readAtIso
        : item.readAt || new Date().toISOString(),
  };
}

/**
 * Substitui um item na lista pelo id (imutável).
 * @param {Object[]} list
 * @param {string} notificationId
 * @param {Object|null} nextItem
 * @returns {Object[]}
 */
export function replaceNotificationInList(list, notificationId, nextItem) {
  if (!Array.isArray(list)) return [];
  const id = typeof notificationId === "string" ? notificationId.trim() : "";
  if (!id) return list;

  return list.map((item) => (item?.id === id ? nextItem ?? item : item));
}

/**
 * Encontra o item na lista para snapshot de rollback.
 * @param {Object[]} list
 * @param {string} notificationId
 * @returns {Object|null}
 */
export function findNotificationInList(list, notificationId) {
  if (!Array.isArray(list)) return null;
  const id = typeof notificationId === "string" ? notificationId.trim() : "";
  if (!id) return null;

  const found = list.find((item) => item?.id === id);
  return found ? { ...found } : null;
}
